import { CANTRATE_ID } from '@webapp/common/resources/constants';

import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class NpsApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const { id, responseActor } = actor.getSnapshot().context;
        const { comment, value } = responseActor.getSnapshot().context;
        const data = value === CANTRATE_ID ? { cantRate: true } : { int: value as number };

        return {
            question: id,
            data: [{ bool: true, comment, ...data }],
            comment,
        };
    }

    public validate({ params: { required }, responseActor }: QuestionContext): boolean {
        const { value } = responseActor.getSnapshot().context;
        if (required) {
            return value !== undefined && value !== null;
        }

        return true;
    }
}
